export default class NodeDispenser_Orbitals
{
    // Public:
    constructor()
    {
        this.createMasterFunction();
        this.createSlaveFunction();
        this.createFunction();
    }
    
    compute(nodes)
    {
        let func = this._func;
        nodes.forEach(func);
    }

    //Private:
    createFunction()
    {
        let masterFunc = this._masterFunc;
        let slaveFunc = this._slaveFunc;
        let func = function(d)
        {
            switch (d.type)
            {
                case 'master':
                masterFunc(d);
                break;
                case 'slave':
                slaveFunc(d);
                break;
                default:
                console.error('Invalid node type.');
            }            
        }
        this._func = func;
    }
    
    // Private:
    createMasterFunction()
    {
        let computePosInCircleFunc = (o,R) => this.computePositionInCircleFunction(o,R);
        this._masterFunc = function(d)
        {
            let cluster = d.clusters[0];
            let R = 50;
            let position = computePosInCircleFunc(cluster,R);
            d.x = position.x;
            d.y = position.y;
        }
    }
    
    createSlaveFunction()
    {
        let computePosInCircleFunc = (o,R) => this.computePositionInCircleFunction(o,R);
        this._slaveFunc = function(d)
        {
            let maxR = 0;
            let radius = 0;
            let origin = {x:0,y:0};
            let clusters = d.clusters;
            for (let i = 0; i < clusters.length; i++) {
                const cluster = d.clusters[i];
                let R = cluster.radius;
                if (R > maxR)
                {
                    radius = R;
                    origin = {
                        x: cluster.x,
                        y: cluster.y
                    };
                }
            }
            let position = computePosInCircleFunc(origin,radius);
            d.x = position.x;
            d.y = position.y;
        };
    }
    
    computePointsMedian(points)
    {
        let maxX = 0;
        let minX = 100000;
        let maxY = 0;
        let minY = 100000;
        for (let i = 0; i < points.length; i++) {
            const origin = points[i];
            if (origin.x > maxX) maxX = origin.x;
            if (origin.x < minX) minX = origin.x;
            if (origin.y > maxY) maxY = origin.y;
            if (origin.y < minY) minY = origin.y;
        }
        let origin = {
            x: (maxX+minX)/2,
            y: (maxY+minY)/2
        };
        return origin;
    }
    
    computePositionInCircleFunction(origin,R)
    {
        
        let x0 = origin.x;
        let y0 = origin.y;
        let theta = (2*Math.PI) * Math.random();
        let position = {
            x: x0 + R*Math.cos(theta),
            y: y0 + R*Math.sin(theta)
        }
        return position;
    }
    
    computeMax(array)
    {
        let max = 0;
        for (let i = 0; i < array.length; i++) {
            const element = array[i];
            if (element > max) max = element;
        }
        return max;
    }
    
}